import {
    DatalakeApi,
    AuthApi,
    MotiApi,
    SmApi,
    PaymentsApi,
    CommunityApi,
    ReferralsApi
} from './apis'
import {
    BaseAPI,
    Configuration,
    RequestContext,
    ErrorContext,
    ResponseContext
} from './runtime'

import {
    isSessionFailure,
    responseErrorCode,
    unauthorized
} from '@/lib/api/transport'
import { invalidateForWrite } from '@/lib/cacheInvalidation'

export { authTokenLocalStorageKey } from '@/lib/api/authToken'
import { authTokenLocalStorageKey } from '@/lib/api/authToken'

const sessionPolicy = async ({ response, url }: ResponseContext) => {
    if (response.status === 401 || response.status === 403) {
        const code = await responseErrorCode(response)
        if (isSessionFailure(response.status, code)) {
            unauthorized(url)
        }
        // A coded 403 falls through: the runtime throws it as a
        // ResponseError, readable with apiErrorCode.
    }
}

export const config = new Configuration({
    basePath: import.meta.env.VITE_API_HOST,
    accessToken: (name?: string, scopes?: string[]): string => {
        return localStorage.getItem(authTokenLocalStorageKey) || ''
    },
    middleware: [
        {
            post: async (context: ResponseContext) => {
                await sessionPolicy(context)
                if (context.response.ok) {
                    invalidateForWrite(context.init.method, context.url)
                }
                return context.response
            }
        }
    ]
})

export const baseApiClient = new BaseAPI(config)
export const authApiClient = new AuthApi(config)
export const datalakeApiClient = new DatalakeApi(config)
export const motiApiClient = new MotiApi(config)
export const smApiClient = new SmApi(config)
export const paymentsApiClient = new PaymentsApi(config)
export const communityApiClient = new CommunityApi(config)
export const referralsApiClient = new ReferralsApi(config)

/**
 * Analytics beacons (visits, coach engagement): writes that feed no cached
 * query, so they skip cache invalidation. Stats-moving events (workouts,
 * ratings) still go through smApiClient.
 */
export const telemetryClient = new SmApi(
    new Configuration({
        basePath: config.basePath,
        accessToken: () => localStorage.getItem(authTokenLocalStorageKey) || '',
        middleware: [
            {
                post: async (context: ResponseContext) => {
                    await sessionPolicy(context)
                    return context.response
                }
            }
        ]
    })
)
